var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMenu = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 2.829C0 2.039.64 1.4 1.429 1.4H18.57a1.429 1.429 0 1 1 0 2.857H1.43C.639 4.257 0 3.617 0 2.83ZM0 9.97c0-.789.64-1.428 1.429-1.428H18.57a1.429 1.429 0 1 1 0 2.857H1.43A1.427 1.427 0 0 1 0 9.971Zm1.429 5.715a1.429 1.429 0 0 0 0 2.857H18.57a1.429 1.429 0 1 0 0-2.857H1.43Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgMenu);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/menu.eea9ae77f625df99cb58e323797de286.svg";